import { useEffect, useRef } from 'react'

import styles from './Advanceoffice.module.css'

export type AdvanceofficeProps = {
  title?: string
  description?: any
  sponsors?: any
  testimonials?: any
  office?: any
  tabContent?: any
  reviews?: any
}

export const PhnxAdvanceoffice: React.FC<AdvanceofficeProps> = ({
  title,
  description,
  sponsors,
  testimonials,
  office,
  tabContent,
  reviews,
}) => {
  const sectionARef = useRef<HTMLDivElement>(null)
  const sectionBRef = useRef<HTMLDivElement>(null)
  const detailsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const syncHeight = () => {
      if (sectionARef.current && sectionBRef.current && detailsRef.current) {
        const isMobile = window.innerWidth <= 800
        if (isMobile) {
          sectionARef.current.style.height = 'auto'
          return
        }

        const sectionBHeight = sectionBRef.current.offsetHeight
        const detailsHeight = detailsRef.current.offsetHeight

        sectionARef.current.style.height = `${sectionBHeight}px`
        sectionARef.current.style.setProperty('--details-height', `${detailsHeight}px`)
      }
    }

    syncHeight()
    window.addEventListener('resize', syncHeight)

    return () => window.removeEventListener('resize', syncHeight)
  }, [office, testimonials, sponsors])

  return (
    <div className={styles['advanceoffice']}>
      <div className={`container ${styles['text-container']}`}>
        <div className={styles['office-grid']}>
          <div className={styles['section-a']}>
            <div ref={detailsRef} className={`${styles['details']} richText`}>
              <h1>{title && title !== undefined && title}</h1>
              {description && description !== undefined && description}
            </div>
            {reviews && reviews !== undefined && reviews !== null && reviews}
            <div className={styles['tab-group']}>{tabContent}</div>
          </div>

          <div ref={sectionBRef} className={styles['section-b']}>
            <div className={styles['office-details']}>
              {office && office !== undefined && office}
            </div>
            <div className={styles['testimonies']}>
              {testimonials && testimonials !== undefined && testimonials}
            </div>
            <div className="sponsors">{sponsors && sponsors !== undefined && sponsors}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
